import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { configureZod } from './zodIntl';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: 'ro',
    defaultNS: 'lang',
    ns: ['lang', 'formValidation'],
    react: {
      useSuspense: true,
    },
    interpolation: {
      // react already safes from xss
      escapeValue: false,
    },
    saveMissing: false,
    backend: {
      queryStringParams: { v: import.meta.env.BUILD_TIMESTAMP },
    },
  })
  .then(configureZod);

export default i18n;
